enum Step {
  TeamsSetup = 'teamsSetup',
  FinishedOnboarding = 'closedOnboardingVideo',
  NotInitialized = 'notInitialized'
}

export function isStep(value: string): value is Step {
  return (Object.values(Step) as string[]).includes(value);
}

export default Step;
